import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M810-443 163-171q-21 9-38-3-18-11-18-32v-548q0-21 18-32 17-12 38-4l647 273q24 10 24 37t-24 37ZM180-259l528-221-528-224v156l248 68-248 66v155Zm0 0v-445 445Z"/>',
  f: '<path d="M163-171q-21 9-38-3-18-11-18-32v-187l321-87-321-89v-185q0-21 18-32 17-12 38-4l647 273q24 10 24 37t-24 37L163-171Z"/>',
};

export default data;
